import { passwordSpecialCharRegex } from './validators';

interface ValidationRule {
  id: string;
  label: string;
  test: (value: string) => boolean;
}

export const PASSWORD_VALIDATION_RULES: ValidationRule[] = [
  {
    id: 'minLength',
    label: 'At least 8 characters',
    test: (value) => value.length >= 8,
  },
  {
    id: 'uppercase',
    label: 'At least one uppercase letter',
    test: (value) => /[A-Z]/.test(value),
  },
  {
    id: 'number',
    label: 'At least one number',
    test: (value) => /[0-9]/.test(value),
  },
  {
    id: 'specialChar',
    label: 'At least one special character',
    test: (value) => passwordSpecialCharRegex.test(value),
  },
  {
    id: 'noSpaces',
    label: 'No spaces allowed',
    test: (value) => value.length > 0 && /^\S*$/.test(value),
  },
  {
    id: 'lowercase',
    label: 'At least one lowercase letter',
    test: (value) => /[a-z]/.test(value),
  },
];